import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { JSX } from 'react';
import { NumericFormat, OnValueChange } from 'react-number-format';

/**
 * Edit cell for B&S business interest value
 */
const DataGridEditBusinessInterestCell = ({
  id,
  value,
  field,
}: GridRenderEditCellParams): JSX.Element => {
  const apiRef = useGridApiContext();
  // Calculate maximum value that user can enter (sum of all other interests must be <= 100)
  const interestTotal = [...apiRef.current.getRowModels().values()].reduce(
    (accumulator, item) =>
      // Ignoring interest of current row
      accumulator + (item.interest && item.fnaPartyID !== id ? item.interest : 0),
    0,
  );
  // Avoid floating point arithmetic issues by rounding to 2 decimal places
  const availableInterestMax = Number((100 - interestTotal).toFixed(2));

  const handleValueChange: OnValueChange = (values): void => {
    apiRef.current.setEditCellValue({ id, field, value: values.floatValue });
  };

  return (
    <NumericFormat
      autoFocus
      isAllowed={({ floatValue }): boolean => {
        return !floatValue || floatValue <= availableInterestMax;
      }}
      className="w-full h-full p-2"
      value={value || ''}
      onValueChange={handleValueChange}
    />
  );
};

export default DataGridEditBusinessInterestCell;
